import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';

export default function TooltipSimple(props) {
  const { 
    title = '',
    placement = 'bottom',
    children
  } = props;

  return (
    <ThemeProvider theme={backYouTheme}>
      <Tooltip
        style={{ ...props.style }}
        title={title} 
        placement={placement}
        arrow
        PopperProps={{
          style: { zIndex: 9999 }
        }}
      >
        {children}
      </Tooltip>          
    </ThemeProvider>
  )
}